import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { IconTile } from '@/components/IconTile';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconHome from '@/assets/icons/heroIcons/Home.svg';
import IconSun from '@/assets/icons/heroIcons/Sun.svg';
import IconDumplingHappy from '@/assets/icons/heroIcons/DumplingHappy.svg';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconCake from '@/assets/icons/heroIcons/Cake.svg';
import IconUsers from '@/assets/icons/heroIcons/User-group.svg';
import IconPresentationChartBar from '@/assets/icons/heroIcons/PresentationChartBar.svg';
import IconGlobe from '@/assets/icons/heroIcons/Globe.svg';
export function Advantages() {
  const $ = _c(56);
  const {
    t
  } = useTranslation("career");
  let t0;
  if ($[0] !== t) {
    t0 = t("advantages.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionHeadline className="mx-auto mb-10 max-w-157 px-0 lg:mb-16" anchorKey="advantages.title">{t0}</SectionHeadline>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("advantages.items.1");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconTile icon={<IconHome />} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = {
      title: t2,
      icon: t3
    };
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("advantages.items.2");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile icon={<IconSun />} />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = {
      title: t5,
      icon: t6
    };
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("advantages.items.3");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconTile icon={<IconDumplingHappy />} />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = {
      title: t8,
      icon: t9
    };
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("advantages.items.4");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IconTile icon={<IconPay />} />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = {
      title: t11,
      icon: t12
    };
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t("advantages.items.5");
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconTile icon={<IconGlobe />} />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14) {
    t16 = {
      title: t14,
      icon: t15
    };
    $[27] = t14;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("advantages.items.6");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <IconTile icon={<IconCake />} />;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t17) {
    t19 = {
      title: t17,
      icon: t18
    };
    $[32] = t17;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t) {
    t20 = t("advantages.items.7");
    $[34] = t;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <IconTile icon={<IconUsers />} />;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t20) {
    t22 = {
      title: t20,
      icon: t21
    };
    $[37] = t20;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t) {
    t23 = t("advantages.items.8");
    $[39] = t;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <IconTile icon={<IconPresentationChartBar />} />;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23) {
    t25 = {
      title: t23,
      icon: t24
    };
    $[42] = t23;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t10 || $[45] !== t13 || $[46] !== t16 || $[47] !== t19 || $[48] !== t22 || $[49] !== t25 || $[50] !== t4 || $[51] !== t7) {
    t26 = <BenefitTiles items={[t4, t7, t10, t13, t16, t19, t22, t25]} />;
    $[44] = t10;
    $[45] = t13;
    $[46] = t16;
    $[47] = t19;
    $[48] = t22;
    $[49] = t25;
    $[50] = t4;
    $[51] = t7;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t1 || $[54] !== t26) {
    t27 = <div className="px-4">{t1}{t26}</div>;
    $[53] = t1;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  return t27;
}